/* global $ */
'use strict';

function Loader(EVENTS) {
	var PubSub = require('pubsub-js');

	function firsLoadDone(msg, data) {
		PubSub.subscribe(EVENTS.LAZYLOAD_IMAGES, lazyLoadImages);
		PubSub.subscribe(EVENTS.LAZYLOAD_SLICK, lazyLoadSlick);

		if ($(window).width() >= 769) {
			lazyLoadImages(msg, 'desktop-view');
		} else {
			lazyLoadImages(msg, window.NIKE.currentPageId);
		}
	}

	function lazyLoadImages(msg, data) {
		if (data !== 'opened') {
			$('#' + data).find('.lazyLoad').not('.lazyLoad-loaded').each(function () {
				var $this = $(this);
				var img = $('<img />');
				if ($this.attr('data-src')) {
					img.on({
						load: function () {
							$this.addClass('lazyLoad-loaded').attr('src', img.attr('src')).parent().removeClass('lazyLoad-loading');
						},
						error: function () {
							console.log('Error thrown, image didn\'t load, probably a 404.');
						}
					});
					img.attr('src', $this.attr('data-src'));
				}
				if ($this.attr('data-bg')) {
					img.on({
						load: function () {
							$this.addClass('lazyLoad-loaded').removeClass('lazyLoad-loading').css('background-image', 'url(' + img.attr('src') + ')');
						},
						error: function () {
							console.log('Error thrown, image didn\'t load, probably a 404.');
						}
					});
					img.attr('src', $this.attr('data-bg'));
				}
			});
		} else {
			PubSub.publish(EVENTS.LAZYLOAD_SLICK, 1);
		}
	}

	function lazyLoadSlick(msg, data) {
		$('#opened').find('.lazyLoad:eq(' + data + ')').not('.lazyLoad-loaded').each(function () {
			var $this = $(this);
			var img = $('<img />');
			img.on({
				load: function () {
					$this.addClass('lazyLoad-loaded').removeClass('lazyLoad-loading').css('background-image', 'url(' + img.attr('src') + ')');
				},
				error: function () {
					console.log('Error thrown, image didn\'t load, probably a 404.');
				}
			});
			img.attr('src', $this.attr('data-bg'));
		});
	}

	firsLoadDone();
}

module.exports = Loader;
